"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedwaxingandbrows = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 61 43",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedwaxingandbrows` : '') + (description ? ` desc-brandedwaxingandbrows` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedwaxingandbrows"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedwaxingandbrows"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "m35.4 18.5-8.97 4.54-.3-9.93c-.01-.37.5-.59.8-.38l8.47 5.77Z",
    fill: "#F9D29F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37.86 42.46 26.42 23l8.96-4.54 11.04 19.46-8.56 4.54Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m29.12 14.24-2.9 1.4-.09-2.5c-.01-.4.44-.64.78-.41l2.22 1.5Z",
    fill: "#5D2F14"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48.13 3.21c4.65 1.42 9.5 3.11 11.65 5.71.66.92.09 3.4-3.08 2.6-16.31-2.9-33.44-.1-41.97 3.03-5.44 1.52-10.45 1.85-13.18-.65C.13 12.62-.15 10.71.12 9.12c1.8-5.28 9.7-6.54 16.04-7.52a83.18 83.18 0 0 1 31.97 1.6v.01Z",
    fill: "#874B28"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.76 8.71c-2.14-2.52-7-4.17-11.64-5.56A87.28 87.28 0 0 0 30 .77V11.1c8.03-1 17.3-1.2 26.5.41 3.5 1 3.92-1.9 3.26-2.79Z",
    fill: "#5D2F14"
  }));
};
var _default = exports.default = brandedwaxingandbrows;